import React, { useContext, useEffect, useState } from "react";
import loadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { AppContext } from "../../contexts/AppContext";
import RequestRow from "./RequestRow";
import { UserContext } from "../../contexts/UserContext";
import ComposeNewEmail from "../../components/EmailUI/ComposeNewEmail";

export default function ConsultantRequests({
  project_id,
  project_name,
  setEmailDetails,
  setComposeEmail,
  backupData,
  setBackupData,
  screeningQuestions,
  projectType,
}) {
  const [requests, setRequests] = useState([]);
  const { userData, projectApplication } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [seeMoreDescription, setSeeMoreDescription] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [loadQuestions, setLoadQuestions] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  const { queAnswers, setQueAnswers } = useContext(AppContext);
  const [acceptRequest, setAcceptRequest] = useState(false);
  const [rejectRequest, setRejectRequest] = useState(false);
  const [expertsData, setExpertsData] = useState([]);
  const [expertName, setExpertName] = useState(null);
  const [modifiedSubject, setModifiedSubject] = useState("");
  const [modifiedSubjectReject, setModifiedSubjectReject] = useState("");
  const [modifiedBody, setModifiedBody] = useState("");
  const [modifiedBodyReject, setModifiedBodyReject] = useState();
  const [requestSelected, setRequestSelected] = useState(null);
  const [acceptTemplate, setAcceptTemplate] = useState([]);
  const [rejectTemplate, setRejectTemplate] = useState([]);
  // const [isSuccess, setIsSuccess] = useState(false);

  // Generate email templates
  useEffect(() => {
    const accept = generateAcceptTemplates(expertName?.name, userData?.username, project_name);
    const reject = generateRejectTemplates(expertName?.name, userData?.username, project_name);
    setAcceptTemplate(accept);
    setRejectTemplate(reject);
  }, [expertName]);

  // Fetch consultant requests
  useEffect(() => {
    setLoading(true);
    const url = `${API_URL}requests-for-project/${project_id}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setRequests(data.data);
        setLoadQuestions(!loadQuestions);
        if (data.status == "error") {
          Swal.fire({
            title: `${data.message}`,
            icon: "error",
            showConfirmButton: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Something Went Wrong!",
          icon: "error",
          timer: 2000,
        });
      });
  }, [projectApplication]);

  // Fetch question and answers
  useEffect(() => {
    if (requests.length > 0) {
      setLoadingQuestions(true);
      requests.map((req, index) => {
        if (!req.firstQuestion && !req.secondQuestion) {
          const url = `${API_URL}fetch-question-answers`;
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ projID: project_id, expertID: req.expert }),
          })
            .then((res) => res.json())
            .then((data) => {
              const newArr = [...requests];
              newArr[index] = {
                ...newArr[index],
                screeningQuestions: data.responses,
              };
              setRequests(newArr);
            })
            .catch((err) => console.log(err));
        }
      });
    }
  }, [queAnswers]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     if (acceptRequest) {
  //       addToProjectHandle();
  //     };
  //     if (rejectRequest) {
  //       rejectFromProject();
  //     }
  //   }
  // }, [isSuccess]);

  // useEffect(() => {
  //   if (acceptRequest || rejectRequest) {
  //     setIsSuccess(false);
  //   }
  // }, [acceptRequest, rejectRequest]);

  const addToProjectHandle = (_payload = {}) => {
    setLoadingAdd(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const accessToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}add-from-request`;
    const confirmationMail = '';

    fetch(url, {
      method: "POST",
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      body: JSON.stringify({
        expertID: requestSelected.ID,
        email: requestSelected.email,
        projectID: project_id,
        requestID: requestSelected.request_id,
        summary: `${requestSelected.firstQuestion}\n\n${requestSelected.secondQuestion}`,
        subject: modifiedSubject,
        confirmationMail,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingAdd(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Consultat added to this project",
            icon: "success",
            confirmButtonText: "OK",
          });
          setRequests(
            requests.filter(
              (req) => req.request_id != requestSelected.request_id
            )
          );
          window.location.reload();
        } else if (data.status === "error") {
          Swal.fire({
            title: "Error!",
            text: `${data.msg}`,
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
        });
      });
  };

  const rejectFromProject = (_payload = {}) => {
    setLoadingAdd(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const accessToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}reject-from-request`;
    const confirmationMail = '';

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
        Authorization: accessToken,
      },
      body: JSON.stringify({
        email: requestSelected.email,
        requestID: requestSelected.request_id,
        subject: modifiedSubjectReject,
        confirmationMail,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingAdd(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Consultat rejected from this project",
            icon: "success",
            confirmButtonText: "OK",
          });
          setRequests(
            requests.filter(
              (req) => req.request_id != requestSelected.request_id
            )
          );
          window.location.reload();
        } else if (data.status === "error") {
          Swal.fire({
            title: "Error!",
            text: `${data.msg}`,
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
        });
      });
  };

  const generateAcceptTemplates = (expertName, userName, projectName) => {
    const firstName = typeof expertName === "string" && expertName.trim().length > 0
      ? expertName.trim().split(" ")[0]
      : expertName;

    return [
      {
        lang: "en",
        label: "English",
        name: "Application Acknowledgment",
        subject: `expertpowerhouse | Your application to "${projectName}" has been accepted`,
        value: `
          <div>Dear ${firstName},</div>
          <div><br></div>
          <div>Many thanks for your application for the project opportunity "${projectName}" via our platform. We would be very happy to present your profile to our client. Should we have any questions, we will reach out to you shortly. Otherwise, we will let you know should the client be interested in your profile and arrange all further steps.</div>
          <div><br></div>
          <div>Best regards,</div>
          <div>${userName}</div>
        `
      },
      {
        lang: "de",
        label: "German",
        name: "Bewerbungsbestätigung",
        subject: `expertpowerhouse | Die Bewerbung für "${projectName}" wurde angenommen`,
        value: `
          <div>Hallo ${firstName},</div>
          <div><br></div>
          <div>vielen Dank für die Bewerbung für das Projekt "${projectName}" über unsere Plattform. Wir würden dein Profil sehr gerne unserem Kunden vorstellen. Sollten wir Rückfragen haben, werden wir uns zeitnah melden. Andernfalls informieren wir dich, sobald der Kunde Interesse an deinem Profil zeigt, und koordinieren alle weiteren Schritte.</div>
          <div><br></div>
          <div>Viele Grüße,</div>
          <div>${userName}</div>
        `
      }
    ];
  };

  const generateRejectTemplates = (expertName, userName, projectName) => {
    const firstName = typeof expertName === "string" && expertName.trim().length > 0
      ? expertName.trim().split(" ")[0]
      : expertName;

    return [
      {
        lang: "en",
        label: "English",
        name: "Rejection – Project Application",
        subject: `expertpowerhouse | Your application for "${projectName}" was not successful`,
        value: `
          <div>Dear ${firstName},</div>
          <div><br></div>
          <div>Many thanks for your application for the project opportunity "${projectName}" via our platform. Unfortunately, we are not able to consider you this time. I hope we will find other opportunities shortly.</div>
          <div><br></div>
          <div>Best regards,</div>
          <div>${userName}</div>
        `
      },
      {
        lang: "de",
        label: "German",
        name: "Absage – Projektbewerbung",
        subject: `expertpowerhouse | Die Bewerbung für "${projectName}" war leider nicht erfolgreich`,
        value: `
          <div>Hallo ${firstName},</div>
          <div><br></div>
          <div>vielen Dank für die Bewerbung für das Projekt "${projectName}" über unsere Plattform. Leider können wir dich dieses Mal nicht berücksichtigen. Wir hoffen jedoch, dass in Kürze passendere Projektmöglichkeiten bestehen.</div>
          <div><br></div>
          <div>Viele Grüße,</div>
          <div>${userName}</div>
        `
      }
    ];
  };

  return (
    <>
      <div className="project-details-request-container">
        {!showDetails ? (
          <div
            className={requests.length > 0 ? "project-details-request-div" : ""}
            onClick={() => setShowDetails(true)}
          >
            <span className="project-details-span">
              {requests.length > 0 ? (
                <>
                  <span className="project-details-span-number">
                    {requests.length}
                  </span>
                  <span>APPLICATIONS READY FOR REVIEW</span>
                </>
              ) : null}
            </span>
          </div>
        ) : (
          <div>
            {requests.map((item) => (
              <div className="project-details-request-div-extend">
                {loadingAdd && requestSelected?.request_id === item.request_id ? (
                  <div className="loading-icon flex justify-center items-center">
                    <i class="fa-solid fa-spinner fa-spin" style={{fontSize: "20px", color: "#365561"}}></i>
                  </div>
                ) : (
                  <RequestRow
                    data={item}
                    project_id={project_id}
                    questions={item.firstQuestion + item.secondQuestion}
                    project_name={project_name}
                    setEmailDetails={setEmailDetails}
                    setComposeEmail={setComposeEmail}
                    backupData={backupData}
                    setBackupData={setBackupData}
                    setAcceptRequest={setAcceptRequest}
                    setRejectRequest={setRejectRequest}
                    setExpertName={setExpertName}
                    setRequestSelected={setRequestSelected}
                    request={item}
                    screeningQuestions={screeningQuestions}
                    projectType={projectType}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {acceptRequest && (
        <ComposeNewEmail
          onClose={() => setAcceptRequest(false)}
          defaultTo={[requestSelected?.email]}
          defaultTemplates={acceptTemplate}
          // setSuccess={setIsSuccess}
          logFunction={addToProjectHandle}
        />
      )}

      {rejectRequest && (
        <ComposeNewEmail
          onClose={() => setRejectRequest(false)}
          defaultTo={[requestSelected?.email]}
          defaultTemplates={rejectTemplate}
          // setSuccess={setIsSuccess}
          logFunction={rejectFromProject}
        />
      )}
    </>
  );
}
